import { render } from "./LanguageDialog.vue?vue&type=template&id=df4268be&scoped=true"
import script from "./LanguageDialog.vue?vue&type=script&lang=js"
export * from "./LanguageDialog.vue?vue&type=script&lang=js"

import "./LanguageDialog.vue?vue&type=style&index=0&id=df4268be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df4268be"]])

export default __exports__